import FootballState from "../../state/football-state";
import Rule from "../../../common/rule";

export default class IsRegularGameRule extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        return !play?.historyContains?.(FootballState.PatTry);
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration) {}
}
